import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { OrderDetailInfoCardComponent } from './components/order-detail-info-card/order-detail-info-card';
import { OrderDetailLocationCardComponent } from './components/order-detail-location-card/order-detail-location-card';
import { OrderDetailPage } from './order-detail';
import { OrderDetailTasksListComponent } from './components/order-detail-tasks-list/order-detail-tasks-list';
import { OrderItemsCardComponent } from './components/order-items-card/order-items-card';

@NgModule({
  declarations: [
    OrderDetailPage,
    OrderDetailInfoCardComponent,
    OrderDetailLocationCardComponent,
    OrderDetailTasksListComponent,
    OrderItemsCardComponent,
  ],
  imports: [IonicPageModule.forChild(OrderDetailPage)],
})
export class OrderDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-detail/order-detail.module.ts